export const SHOW_TOAST = 'SHOW_TOAST'

export interface ToastInfos {
  toastIds: string[]
}
